import { render, staticRenderFns } from "./setOptimalLeverages.popup-chunk.vue?vue&type=template&id=38b22d3e&scoped=true"
import script from "./setOptimalLeverages.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./setOptimalLeverages.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./setOptimalLeverages.popup-chunk.vue?vue&type=style&index=0&id=38b22d3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b22d3e",
  null
  
)

export default component.exports